import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const ActionBarItemListItem = (props) => {
    const { hasLink, icon, onClick, className, children } = props, remainingProps = __rest(props, ["hasLink", "icon", "onClick", "className", "children"]);
    const classes = classNames('ActionBarItemListItem', hasLink && 'has-link', className);
    const iconClasses = classNames('ActionBarItemListItemIcon', 'rioglyph', icon);
    const btnClasses = classNames('ActionBarItemListItemButton');
    return (_jsxs("li", Object.assign({}, remainingProps, { className: classes, onClick: onClick }, { children: [icon && _jsx("span", { className: iconClasses }), hasLink && !onClick && _jsx("span", { children: children }), onClick && _jsx("div", Object.assign({ className: btnClasses }, { children: children })), !hasLink && !onClick && children] })));
};
export default ActionBarItemListItem;
